import { Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { ExpandableDescription } from 'components/ExpandableDescription'
import { Book } from '@fable/types'

export const BookDetailDescription = ({ book }: { book: Book }) => {
  const description = book?.description || ''
  const { colors } = useTheme()

  if (!description || !description.length) return null

  return (
    <div>
      <Text tag="h2" type="header" sizing="XS" color={colors.uiGraphite}>
        Publisher Description
      </Text>
      <ExpandableDescription
        className={css`
          margin-top: 24px;
        `}
        truncate={12}
        description={description}
      />
    </div>
  )
}
